<template>
  <b-row align-h="center" class="mx-0">
    <b-col lg="8">
      <b-row class="panel-section">
        <b-col lg="6">
          <div class="panel-section-title">
            <slot name="title"></slot>
          </div>
        </b-col>
        <b-col cols="1"></b-col>
        <b-col cols="5">
          <slot name="content"></slot>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'ConfigPanelSection'
}
</script>

<style scoped>
.panel-section {
  padding: 2em 0;
  border-bottom: 1px solid #f2f2f2;
}
.panel-section-title {
  padding-bottom: 2em;
}
.panel-section-title p {
  font-size: 18px;
  color: #163D7D;
}
</style>
